import moment from "moment";
import { displayDateFormat } from "../../../utils/helpers";
import { resolveVoucherListRowId } from "../../../../srcWeb/utils/dmsStandaloneListUtils";

function formatSubmittedOnCell(raw) {
  if (raw == null || String(raw).trim() === "") return "-";
  const s = String(raw).trim();
  let m = moment(s, "DD-MMM-YYYY HH:mm", true);
  if (!m.isValid()) m = moment(s, "DD-MMM-YYYY H:mm", true);
  if (!m.isValid()) m = moment(s, moment.ISO_8601, true);
  if (!m.isValid()) m = moment(s);
  if (!m.isValid()) return s;
  return m.format(displayDateFormat);
}

export const storeColumns = ({
  navigate,
  downloadVoucher,
  navigationStateExtras = {},
}) => [
  {
    Header: "V.ID",
    accessor: "vid",
    Cell: (props) => {
      const original = props?.row?.original ?? props;
      const id = resolveVoucherListRowId(original);
      const allData = original;
      if (!id) return <span>-</span>;

      return (
        <div
          className="cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (id) {
              navigate(`/vouchers/${id}`, {
                state: { ...allData, ...navigationStateExtras },
              });
            }
          }}
        >
          {id}
        </div>
      );
    },
  },
  {
    Header: "Submit On",
    accessor: "submittedOn",
    Cell: (rowData) => {
      const raw =
        rowData?.submittedOn ??
        rowData?.row?.original?.submittedOn ??
        rowData?.createdOn ??
        rowData?.row?.original?.createdOn;
      if (!raw) return "-";
      return <div>{formatSubmittedOnCell(raw)}</div>;
    },
  },
  {
    Header: "Amount (₹)",
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.amount;
      let amount;
      if (typeof value == "string") {
        amount = Number(value).toFixed(2);
      } else {
        amount = value;
      }
      return amount || "-";
    },
  },
  {
    Header: "L1 Status",
    accessor: "l1_status",
    Cell: (rowData) => {
      const value = rowData?.L1?.status;
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              : value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "L2 Status",
    accessor: "l2_status",
    Cell: (rowData) => {
      const value = rowData?.L2?.status;
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              : value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "A/C Status",
    accessor: "ac_status",
    Cell: (rowData) => {
      const value = rowData?.L3?.status;
      // console.log(rowData.row?.original, "ori");
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              : value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "Approved Amount (₹)",
    accessor: "approved_amount",
    Cell: (rowData) => {
      const value = rowData?.L3?.approvedAmount
        ? Number(rowData?.L3?.approvedAmount).toFixed(2)
        : "-";
      return (
        <div className={"text-[var(--successGreen)]"}>
          {value ? Number(value).toFixed(2) : value}
        </div>
      );
    },
  },
  {
    Header: "Action",
    accessor: "",
    Cell: (rowData) => {
      return (
        <div className="flex items-center gap-x-5">
          <div
            className={`cursor-pointer text-[#346BFF] underline text-[1.4rem]}`}
            onClick={() => {
              downloadVoucher(rowData, "All");
              // return onClickViewFile(rowData?.id, rowData)
            }}
          >
            Download
          </div>
        </div>
      );
    },
  },
];

export const l1Columns = ({ extraColumns = [], downloadVoucher }) => [
  ...extraColumns,
  {
    Header: "Submit On",
    accessor: "submittedOn",
    Cell: (rowData) => {
      if (!rowData?.submittedOn) {
        return "-";
      }
      return <div>{rowData?.submittedOn}</div>;
    },
  },
  {
    Header: "Amount (₹)",
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.amount;
      let amount;
      if (typeof value == "string") {
        amount = Number(value).toFixed(2);
      } else {
        amount = value;
      }
      return amount || "-";
    },
  },
  {
    Header: "Approved",
    accessor: "approved",
    Cell: (rowData) => {
      const value = rowData?.approvedAmount;
      if (!value) {
        return "-";
      }
      return <div className={"text-[var(--successGreen)]"}>{value}</div>;
    },
  },
  {
    Header: "Pending",
    accessor: "pendingAmount",
    Cell: (rowData) => {
      const value = rowData?.pendingAmount;
      if (!value) {
        return "-";
      }
      return <div className={"text-[var(--pendingYellow)]"}>{value}</div>;
    },
  },
  {
    Header: "Rejected",
    accessor: "rejectedAmount",
    Cell: (rowData) => {
      const value = rowData?.rejectedAmount;
      if (!value) {
        return "-";
      }
      return <div className={"text-[var(--textRed)]"}>{value}</div>;
    },
  },
  // {
  //   Header: "Action",
  //   accessor: "",
  //   Cell: (rowData) => {
  //     return (
  //       <div className="flex items-center gap-x-5">
  //         <div
  //           className={`cursor-pointer text-[#346BFF] underline text-[1.4rem]}`}
  //           onClick={() => {
  //             downloadVoucher(rowData, "All")
  //             // return onClickViewFile(rowData?.id, rowData)
  //           }}
  //         >
  //           Download
  //         </div>
  //       </div>
  //     );
  //   },
  // },
];
